/*
ssg
用户信息,权限处理
*/
const state = {
    userInfo: {
        id: '',
    }
}
const getters = {
    getUser: state => {
        let tempInfo = localStorage.getItem("userInfo")
        if (tempInfo)
            state.userInfo = JSON.parse(tempInfo)
        return state.userInfo
    }
}
const mutations = {
    setUser(state, userInfo) {
        state.userInfo = userInfo
        localStorage.setItem('userInfo', JSON.stringify(userInfo))
    }
}
const actions = {
    setUserInfo({ commit }, userInfo) {
        commit('setMyUserInfo', { userInfo })
    }
}
export default {
    state,
    getters,
    mutations,
    actions
}